import d3 = require("d3");
import React = require("react");
import ReactFauxDOM = require("react-faux-dom");
import {removeNaN} from "../../../../../Utils/Utils";

interface Size {
    width: number;
    height: number;
}

interface Range {
    color: string;
    fromValue: number;
    toValue: number;
}

interface WidgetProps {
    size: Size;
    value: number;
    minValue: number;
    maxValue: number;
    unitOfMeasure: string;
    defaultColor?: string;
    ranges?: Range[];
}

export class LinearGaugeWithRange extends React.Component<WidgetProps, any> {

    public static toX(fromValue: number, svgWidth: number, minValue: number, maxValue: number, margin: number) {
        return margin + svgWidth * (fromValue - minValue) / (maxValue - minValue);
    }

    private DEFAULT_COLOR: string = "rgba(105, 255, 79, 0.7)";
    private LINE_COLOR: string = "#b7b7b7";
    private TICK_HEIGHT: number = 5;

    constructor(props) {
        super(props);
    }

    public render() {
        const div = new ReactFauxDOM.Element("div");
        const barHeight = this.props.size.height / 3;
        const svg = d3.select(div)
            .append("svg")
            .attr("width", this.props.size.width)
            .attr("height", this.props.size.height);
        const lineY = barHeight * 2 + 2;
        const margin = 30;
        svg.append("line")
            .attr("x1", margin)
            .attr("y1", lineY)
            .attr("x2", removeNaN(this.props.size.width - margin, 0))
            .attr("y2", lineY)
            .attr("stroke-width", 1)
            .attr("stroke", this.LINE_COLOR);
        const width = this.props.size.width - 2 * margin;
        if (this.props.ranges && this.props.ranges.length > 0) {
            this.props.ranges.forEach((range: Range, index: number) => {
                svg.append("rect")
                    .attr(
                        "x",
                        LinearGaugeWithRange.toX(
                            range.fromValue,
                            width,
                            this.props.minValue,
                            this.props.maxValue,
                            margin,
                        ),
                    )
                    .attr("y", barHeight)
                    .attr(
                        "width",
                        LinearGaugeWithRange.toX(
                            range.toValue, width, this.props.minValue, this.props.maxValue, margin) -
                        LinearGaugeWithRange.toX(
                            range.fromValue, width, this.props.minValue, this.props.maxValue, margin),
                    )
                    .attr("height", barHeight)
                    .attr("fill", range.color);
                this.drawTick(
                    svg, range.fromValue, width, this.props.minValue, this.props.maxValue, lineY, margin);
                if (index === this.props.ranges.length - 1) {
                    this.drawTick(
                        svg, range.toValue, width, this.props.minValue, this.props.maxValue, lineY, margin);
                }
            });
        } else {
            svg.append("rect")
                .attr(
                    "x",
                    LinearGaugeWithRange.toX(
                        this.props.minValue, width, this.props.minValue, this.props.maxValue, margin),
                )
                .attr("y", barHeight)
                .attr("width", width)
                .attr("height", barHeight)
                .attr("fill", this.props.defaultColor ? this.props.defaultColor : this.DEFAULT_COLOR);
            this.drawTick(
                svg, this.props.minValue, width, this.props.minValue, this.props.maxValue, lineY, margin);
            this.drawTick(
                svg, this.props.maxValue, width, this.props.minValue, this.props.maxValue, lineY, margin);
        }
        this.drawMarker(
            svg, this.props.value, width, this.props.minValue, this.props.maxValue, barHeight, margin);
        return div.toReact();
    }

    private drawMarker(
        svg: any, atValue: number, svgWidth: number, minValue: number, maxValue: number, barY: number, margin: number,
    ) {
        if (atValue == null) {
            return;
        }
        let atValTmp = atValue;
        if (atValue < minValue) {
            atValTmp = minValue;
        }
        if (atValue > maxValue) {
            atValTmp = maxValue;
        }
        const x = LinearGaugeWithRange.toX(atValTmp, svgWidth, minValue, maxValue, margin);
        const triangle = d3.symbol()
            .type(d3.symbolTriangle)
            .size(barY + 20);
        svg.append("path")
            .attr("d", triangle)
            .attr("stroke", "red")
            .attr("fill", "white")
            .attr("transform", "translate(" + x + "," + (barY - 8) + ") rotate(180)");
        svg.append("text")
            .attr("x", x)
            .attr("y", barY - 15)
            .attr("text-anchor", "middle")
            .classed("linear-gauge-value", false)
            .text(atValue.toFixed(1) + " " + this.props.unitOfMeasure);
    }

    private drawTick(
        svg: any, atValue: number, svgWidth: number, minValue: number, maxValue: number, y: number, margin: number,
    ) {
        const x = LinearGaugeWithRange.toX(atValue, svgWidth, minValue, maxValue, margin);
        svg.append("line")
            .attr("x1", x)
            .attr("y1", y)
            .attr("x2", removeNaN(x, 0))
            .attr("y2", y + this.TICK_HEIGHT)
            .attr("stroke-width", 1)
            .attr("stroke", this.LINE_COLOR);

        svg.append("text")
            .attr("x", x)
            .attr("y", y + this.TICK_HEIGHT + 10)
            .attr("text-anchor", "middle")
            .classed("linear-gauge-value", false)
            .text(atValue.toFixed(atValue > 10 ? 1 : 2));
    }
}
